import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "./global-search.css";
import axios from "axios";
import {
  BASE_URL,
  CATEGORY_COMPLETE_NAME_MAP,
  CATEGORY_NAME_MAP,
  ROUTES
} from "../assets/constant";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../components/loader";
import PropTypes from "prop-types";
import { convertInMonthNameFormat, highlightText } from "../utils/helper";

export const GlobalSearch = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoadedCompletely, setDataLoadedCompletely] = useState(false);

  const user = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const page = useRef(1);

  const fetchData = useCallback(async () => {
    try {
      if (page.current === 1) {
        setData([]);
      }

      const paramObj = {};
      if (user.globalSearch.category) {
        paramObj.category_id = user.globalSearch.category;
      }
      if (user.globalSearch.recallDate) {
        paramObj.report_date = user.globalSearch.recallDate.split("T")[0];
      }
      if (
        user.globalSearch.manufacturer &&
        user.globalSearch.manufacturer.length
      ) {
        paramObj.manufacturer = user.globalSearch.manufacturer;
      }

      if (paramObj.length) {
        setData([]);
        page.current = 1;
      }
      setIsLoading(true);

      const response = await axios.post(
        `${BASE_URL}/v4.0/global-search`,
        {
          user_id: user.user.id,
          searchQuery: user.globalSearch.search,
          page: page.current,
          params: paramObj
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );
      if (response.data.data.length === 0) {
        setDataLoadedCompletely(true);
      }

      setData((prevData) => [...prevData, ...response.data.data]);
      page.current = page.current + 1;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    page.current = 1;
    fetchData();
  }, [fetchData]);

  const handleRedirect = () => {
    navigate(ROUTES.DASHBOARD);
  };

  return (
    <div className="subscriber-container">
      <div className="global-search-container">
        <div className="global-search-header">
          <span className="global-search-title">
            <button
              className="fa-solid fa-arrow-left"
              style={{ cursor: "pointer", background: "none", border: "none" }}
              onClick={handleRedirect}
              aria-label="Go back"
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleRedirect();
                }
              }}></button>
            <h4 style={{ display: "inline-block", margin: 0 }}>
              Search Results
            </h4>
          </span>
        </div>
        {data.length === 0 && user.globalSearch.search && !isLoading && (
          <div className="text-center mt-5">
            <h5>No Data Found</h5>
          </div>
        )}
        {!isLoading && data.length === 0 && !user.globalSearch.search && (
          <span className="global-search-no-results">
            Type to search amongh all categories
          </span>
        )}
        <InfiniteScroll
          dataLength={data.length}
          next={fetchData} // Fetch more data
          hasMore={!dataLoadedCompletely}>
          <div
            className="myrecalllist"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              minHeight: isLoading ? "60vh" : "auto"
            }}>
            {data?.map((item) => (
              <Card
                key={`${item.id}`}
                item={item}
                searchText={user.globalSearch.search}
              />
            ))}
            {isLoading && data.length === 0 && <Loader />}
          </div>
        </InfiniteScroll>
        {/* </div> */}
      </div>
    </div>
  );
};

const Card = ({ item, searchText }) => {
  const category = CATEGORY_NAME_MAP[item?.category_id];
  const reportedDate = convertInMonthNameFormat(item?.RecallDate);
  const path = ROUTES.RECALL_DETAILS.replace(":type", category).replace(
    ":id",
    item?.id
  );

  return (
    <Link to={`${ROUTES.DASHBOARD}/${path}`} style={{ textDecoration: "none" }}>
      <div className="recalllistcard">
        <div className="card-details">
          <span className="card-title">
            {highlightText(item?.RecallTitle, searchText)}
          </span>
          <span
            style={{ flex: "0 0 auto", marginLeft: "10px", fontSize: "12px" }}>
            {reportedDate}
          </span>
        </div>
        <div className="row">
          <h3 className="card-summary">
            {highlightText(item?.description, searchText)}
          </h3>
        </div>
        <div className="row">
          <span className="category-chip">
            {CATEGORY_COMPLETE_NAME_MAP[category]}
          </span>
        </div>
      </div>
    </Link>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
  searchText: PropTypes.string.isRequired
};
